import React, { useState } from 'react';

const CSVImportModal = ({ onClose, onSubmit }) => {
  const [csvText, setCsvText] = useState("");
  const [preview, setPreview] = useState([]);
  const [error, setError] = useState("");

  const parseCSV = (text) => {
    const lines = text.trim().split("\n");
    const users = [];

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      const parts = line.split(",");
      if (parts.length < 3) {
        setError(
          `Linha ${
            i + 1
          }: Formato inválido. Esperado: nome,email,empresa,telefone (telefone é opcional)`
        );
        return [];
      }

      const user = {
        name: parts[0].trim(),
        email: parts[1].trim(),
        company: parts[2].trim(),
        whatsapp: parts[3] ? parts[3].trim() : "",
      };

      if (!user.name || !user.email || !user.company) {
        setError(`Linha ${i + 1}: Nome, email e empresa são obrigatórios`);
        return [];
      }

      users.push(user);
    }

    return users;
  };

  const handlePreview = () => {
    setError("");
    const users = parseCSV(csvText);
    if (users.length > 0) {
      setPreview(users);
    }
  };

  const handleSubmit = () => {
    if (preview.length > 0) {
      onSubmit(preview);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">Importar Usuários via CSV</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mb-6">
          <p className="text-sm text-gray-600 mb-2">
            Formato: nome,email,empresa,telefone (telefone é opcional)
          </p>
          <p className="text-sm text-gray-600 mb-4">
            Exemplo: João Silva,joao@empresa.com,Empresa ABC,11 999 888 777
          </p>

          <textarea
            value={csvText}
            onChange={(e) => setCsvText(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
            placeholder="Cole aqui os dados CSV..."
          />

          {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

          <div className="mt-4 flex space-x-4">
            <button
              onClick={handlePreview}
              className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg transition-colors duration-200"
            >
              Visualizar
            </button>
            {preview.length > 0 && (
              <button
                onClick={handleSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
              >
                Importar {preview.length} usuários
              </button>
            )}
          </div>
        </div>

        {preview.length > 0 && (
          <div className="border-t pt-6">
            <h3 className="text-lg font-semibold mb-4">Prévia dos Usuários</h3>
            <div className="bg-gray-50 rounded-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Nome</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Email</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                      Empresa
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                      WhatsApp
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {preview.map((user, index) => (
                    <tr key={index} className="border-t border-gray-200">
                      <td className="px-4 py-2 text-sm text-gray-900">{user.name}</td>
                      <td className="px-4 py-2 text-sm text-gray-900">{user.email}</td>
                      <td className="px-4 py-2 text-sm text-gray-900">{user.company}</td>
                      <td className="px-4 py-2 text-sm text-gray-900">{user.whatsapp || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CSVImportModal;
